import { BASE_URL } from '..';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;
import { useNavigate } from 'react-router-dom';

export const api_getOrders = async (pageNo?: number, pageSize?: number) => {
	const page_number = pageNo || 1;
	const page_size = pageSize || 10;
	const uri = `${BASE_URL}/catering/order/?page=${page_number}&offset=${page_size}`;
	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};


export const api_getOrdersByFilter = async (searchString: string) => {
	const uri = `${BASE_URL}/catering/order/filter?searchString=${searchString}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getTotalCateringOrders = async (status: string, date: string) => {
	const token = localStorage.getItem('token');
	const uri = `${BASE_URL}/catering/order/getTotal?status=${status}&date=${date}`;
	console.log(token);
	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			if (response.status === 403) {
				return { isSuccess: false, status: 403 };
			}
			let errorMessage = `HTTP error! Status: ${response.status}`;
			const data = await response.status;
			return { isSuccess: false, data };
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getSubTypes = async () => {
	const uri = `${BASE_URL}/catering/order/sub`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
				// Add your authorization token logic here if needed
			},
		});

		if (!response.ok) {
			throw new Error(
				`Failed to fetch sub types (${response.status} ${response.statusText})`,
			);
		}

		const data = await response.json();

		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const api_getOrderById = async (id: string) => {
	const uri = `${BASE_URL}/catering/order/${id}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};
export const api_createCateringOrder = async (payload: any) => {
	const uri = `${BASE_URL}/catering/order`;

	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the order',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'order created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
export const api_editOrder = async (payload: any, orderId: string) => {
	const uri = `${BASE_URL}/catering/order/${orderId}`;

	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the order',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'order edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteOrder = async (orderId: string) => {
	const uri = `${BASE_URL}/catering/order/${orderId}`;

	try {
		const response = await fetch(uri, {
			method: 'DELETE',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to delete the order',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'order deleted successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
